<div class="container">
    <div class="selected">
        <div *ngIf="isLoading" style="margin-top: 200px;" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
        <table *ngIf="!isLoading" style="width:100%">
            <tr class="back">
                <th>
                  <button class="create" mat-raised-button color="primary" [matMenuTriggerFor]="menu">
                    More
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="markAll()">Acknowledge All Samples</button>
                    <button mat-menu-item [disabled]="disable" (click)="collectAll()">Acknowledge Selected</button>
                  </mat-menu>
                </th>
                <th>Acknowledged</th>
                <th>Service</th>
                <th>Name</th>
              <th>
              </th>
            </tr>
            <tr class="td" *ngFor="let item of samples" style="cursor: pointer;">
                <td><input type="checkbox" [checked]="item.selected" (change)="check(item, $event)"></td>
              <td *ngIf="item.sample_acknowledged == 'N'">{{item.sample_acknowledged}}</td>
              <td *ngIf="item.sample_acknowledged == 'Y'">
                <img style="width: 30px; height: 30px;" src="assets/icons/done.gif" alt="">
              </td>
              <td *ngIf="item.sample_acknowledged == 'N'">{{item.service_name}}</td>
              <td style="background-color: #BE5108; color: white;" *ngIf="item.sample_acknowledged == 'Y'">{{item.service_name}}</td>
              <td>{{item.patient_name}}</td>
              <td>
                <button style="width: 120px;" (click)="onSubmit(item)"  mat-raised-button color="primary"> Acknowledge</button>
              </td>
            </tr>
          </table>
    </div>
</div>
